import { Box } from 'components/box';
import {
  ProductConditionEnum,
  ProductInterface,
  ProductNote,
} from 'types/types';
import { Text } from 'components/typography';
import Button from 'components/button';
import { css } from '@emotion/react';
import config from '../../../../util/load-config';
import { isPhysical as isPhysicalType } from 'types/guards/product';
import { Fragment } from 'react';
import Pill from 'components/_shared/elements/pill';

const ConditionLabel = ({
  condition,
}: {
  condition: ProductConditionEnum | false;
}) => {
  const {
    products: {
      values: { conditions },
    },
  } = config;

  if (
    !condition ||
    !conditions[condition] ||
    condition === ProductConditionEnum.New
  ) {
    return null;
  }

  return (
    <Pill
      color="white"
      backgroundColor="darkGrey"
      css={css`
        display: inline-block;
        margin-right: 8px;
        margin-bottom: 8px;
      `}
    >
      {conditions[condition]}
    </Pill>
  );
};

const Notes = ({ notes }: { notes: ProductNote[] }) => (
  <Box
    css={theme => css`
      display: grid;
      grid-template-columns: auto 1fr;

      @media ${theme.mediaQueries.mobileOnly} {
        display: block;
        border-top: none;
        border-bottom: none;
      }
    `}
  >
    {notes.map((note, idx) => (
      <Fragment key={idx}>
        <Text lineHeight={1.5} fontSize={[1, 2]}>
          {note.value}
        </Text>
      </Fragment>
    ))}
  </Box>
);

const ProductInfo = ({
  product,
  openParallelImportModal,
}: {
  product: ProductInterface;
  openParallelImportModal?: () => void;
}) => {
  let isParallelImport = false;
  let condition: boolean | ProductConditionEnum = false;

  if (isPhysicalType(product)) {
    isParallelImport = product.isParallelImport;
    condition = product.condition;
  }

  const displayCondition =
    !!condition &&
    condition in config.products.values.conditions &&
    condition !== ProductConditionEnum.New;
  const notes =
    product.notes && product.notes.length > 0 ? product.notes : false;

  if (!notes && !isParallelImport && !displayCondition) {
    return null;
  }

  return (
    <Box pt={3}>
      {notes && (
        <Box>
          <Notes notes={notes} />
        </Box>
      )}

      {isParallelImport && (
        <Text fontSize={[1, 2]} color="black">
          Please note that this product is a{' '}
          {openParallelImportModal ? (
            <Button
              color="link"
              p={0}
              variant="flat"
              display="inline-block"
              css={theme => css`
                text-transform: initial;
                letter-spacing: initial;
                font-family: ${theme.fonts.body};
              `}
              onClick={openParallelImportModal}
            >
              parallel import
            </Button>
          ) : (
            <>parallel import</>
          )}
        </Text>
      )}

      {displayCondition && (
        <Box>
          <ConditionLabel condition={condition} />
        </Box>
      )}
    </Box>
  );
};

export default ProductInfo;
